import { isUndefined } from 'lodash';
import { useMemo } from 'react';

import { PrintTemplateSimpleQuery } from '@dreryk/egabinet-document-template-frontend-api';

import { useCqrsCount } from '@dreryk/command-query-react-common';
import { Badge, BadgePosition, BadgeType } from '@dreryk/react-components';
import { Slot } from '@dreryk/watermelon';

import { useDocumentTemplateDraftQuery, useDocumentTemplateRouteMatch } from './DocumentTemplateAction.hooks';

type DocumentTemplateActionBadgeProps = {
   readonly visitId: number;
   readonly children: JSX.Element;
};

export const DocumentTemplateActionBadge = (props: DocumentTemplateActionBadgeProps): JSX.Element => {
   const { priorityTemplateIds, priorityTemplateTypes, refetchDocumentTemplateDrafts } = useDocumentTemplateDraftQuery(
      props.visitId
   );

   const { data: printTemplatesCount } = useCqrsCount(
      () => {
         const query = new PrintTemplateSimpleQuery();
         if (priorityTemplateIds) {
            query.templateIds = Slot.of(priorityTemplateIds);
         }
         return query;
      },
      {
         enabled: Boolean(priorityTemplateIds),
      }
   );

   const numberOfDrafts = useMemo<number>(() => {
      if (isUndefined(printTemplatesCount) || isUndefined(priorityTemplateTypes)) {
         return 0;
      }

      return printTemplatesCount + priorityTemplateTypes.length;
   }, [printTemplatesCount, priorityTemplateTypes]);

   useDocumentTemplateRouteMatch({
      onLeave: refetchDocumentTemplateDrafts,
   });

   return (
      <Badge
         type={BadgeType.WARNING}
         count={numberOfDrafts}
         position={BadgePosition.TOP_RIGHT}
         testId={'availableDrafts'}
         visible={Boolean(numberOfDrafts)}
         compact
      >
         {props.children}
      </Badge>
   );
};
